import React from "react";
import { connect } from "react-redux";
import Contentify from "../../content/Contentify";
import { updateHbsProperties } from "./../../actions/hbs/hbsActions";
import Store from "./../../content/Store";
import Button from "./../shared/buttons/Button";
import { Urls } from "../../constants/UrlConstants";
import ScrollableDetailContainer from "../shared/containers/ScrollableDetailContainer";

export const HbsPopup = (props) => {
  return (
    <React.Fragment>
      <div className="hbsTop">
        <ScrollableDetailContainer>
          <p>
            <strong>{props.content.isThePatientHeader}</strong>
          </p>
          {props.content.isThePatientBody}
        </ScrollableDetailContainer>
      </div>
      <p></p>
      <div className="text-right bookHbstop">
        <Button
          id="HbsButton"
          label="Book an appointment"
          onClick={() => {
            window.open(Urls.HbsLink);
          }}
        />
      </div>
    </React.Fragment>
  );

};

HbsPopup.content = Store.HbsPopup;

export const mapStateToHbsPopup = ({ hbsReducer }) => ({
  isHbsPopupOpen: hbsReducer.isHbsPopupOpen
});

export default
  connect(mapStateToHbsPopup, { updateHbsProperties })(Contentify(HbsPopup));

